// Upload pdf to sign routes
export default [
  {
    path: 'upload-document/:labSampleId',
    name: 'uploadDocument',
    component: () =>
      import(
        /* webpackChunkName: "uploadDocument" */ '../views/uploadDocument/UploadDocument.vue'
      ),
    props: true,
    meta: {
      tabbable: true,
      tableKeys: [],
      filterKeys: [],
      formKeys: [],
      routePermissions: ['analysesStatusManage'],
    },
  },
];
